/**
 * API Client
 * Thin adapter over @tilly/api-client for the Admin UI
 * Injects admin token + Auth0 token retrieval
 */

import { createApiClient } from '@tilly/api-client';
import { tokenService } from '@/auth/token-service';
import { useAdminAuthStore } from '@/stores/adminAuthStore';

const baseUrl =
  import.meta.env.VITE_API_URL && import.meta.env.VITE_API_URL !== ''
    ? `${import.meta.env.VITE_API_URL}/api`
    : '/api';

console.log('[ApiClient] Base URL:', baseUrl);

// Create the API client with config
const apiClient = createApiClient({
  baseUrl,
  getToken: () => tokenService.getToken(),
  getAdminToken: () => useAdminAuthStore.getState().adminToken || null,
  onUnauthorized: () => {
    console.warn('[ApiClient] Unauthorized (401) — clearing auth state');
    useAdminAuthStore.getState().clear();
    window.location.href = '/token-gate';
  },
});

export const {
  platformAdminApi,
  adminBusinessApi,
  adminProvidersApi,
  adminAnalyticsApi,
  adminOutreachApi,
} = apiClient;
export type { ApiClient } from '@tilly/api-client';
